import React, {Component, createRef} from "react";
import FJMultiProcess from 'fj-components/FJMultiProcess';
import FJTimeHandler from "./FJTimeHandler";
import {connect} from 'react-redux'
import {FJPreviewAction, FJTimeLineAction} from "../../../redux/action/FJRoot.action";
import FJTimelineStore from "fj-timeline";
import FJEventConstant from "../../../constant/FJEventConstant";
import FJConfig from '../../../config/FJConfig';
import styles from '../css/FJMultiProcessContainer.module.less'
import key from 'keymaster'

class FJMultiProcessContainer extends Component {

  constructor(props) {
    super(props);
    this.content = createRef();
    this.line = createRef();
  }

  componentDidMount() {
    window.FJEvent.subscribe(FJEventConstant.SEEK_TIMELINE, (e) => {
      e.persist();
      this.content.current.seekStart(e);
      this.content.current.seekChange(e);
      this.content.current.seekEnd(e);
    });

    this._classes = {
      handleClassName: styles.plan_wire_class,
      lineClassName: styles.process_line_class,
      maskClassName: ''
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // TODO 更新滚动条位置
    // if (this.props.isPlaying && prevProps.currentTime !== this.props.currentTime) {
    //   if (this.props.onProgress)
    //     this.props.onProgress(this.props.currentTime / this.props.duration);
    // }
  }

  /**
   * @description 返回进度线的DOMRect
   * @return {DOMRect}
   */
  getProcessLineRect = () => {
    return this.line.current.getProcessLineRect();
  };

  _seek = (type, progress) => {
    if ( type === 'start' ) {
      key.setScope('');
    } else if ( type === 'end' ) {
      key.setScope('default');
    }
    this.props.seek(type, progress);
  };

  _renderTimeHandler = (isDragging) => {
    let {
      contentWidth,
      scrollLeft,
    } = this.props;

    return (
        <FJTimeHandler ref={this.line} isDragging={isDragging} contentWidth={contentWidth} scrollLeft={scrollLeft} classes={this._classes} />
    )
  }

  render() {

    let {
      style,
      isPlaying,
      contentWidth,
      scrollLeft,
      isDragging,
      duration,
      deselectTimeLine,
      children,
      render,
      realDuration
    } = this.props;

    return (
      <FJMultiProcess renderTimeHandler={this._renderTimeHandler}
                      ref={this.content}
                      style={style}
                      scrollLeft={scrollLeft}
                      contentWidth={contentWidth - 16}
                      isPlaying={isPlaying}
                      seek={this._seek}
                      isDragging={isDragging}
                      duration={duration}
                      deselectTimeLine={deselectTimeLine}
                      realDuration={realDuration}
                      maxLimitTime={FJConfig.maxLimitTime}
                      unitConversion={FJTimelineStore.getUnitConversion()}
                      classes={this._classes}
                      render={render}
      >
        {children}
      </FJMultiProcess>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    isPlaying: state.preview.isPlaying,
    isDragging: state.timeline.isDragging,
    duration: state.timeline.duration,
    realDuration: state.timeline.realDuration
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    seek: function (type, progress) {
      dispatch(FJPreviewAction.setVideoProcessAction(type, progress, {isPercent: true, flush: false, useThrottle: true}));
    },
    deselectTimeLine: function () {
      dispatch(FJTimeLineAction.selectTimeLineAction(-1));
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps, null, {forwardRef: true})(FJMultiProcessContainer);
